import logger from "@/logger";
import type { Ref } from "vue";

/* eslint-disable @typescript-eslint/no-unused-expressions */
export function useForceRepaint(element: Ref<HTMLElement>) {
  function triggerRepaint(timeout: number = 0) {
    if (!element.value) {
      logger.error('useForceRepaint: element is null or undefined');
      return
    }
    setTimeout(() => {
      element.value.style.display = 'none';
      element.value.offsetHeight; // trigger reflow
      element.value.style.display = '';
    }, timeout);

  }

  return { triggerRepaint }
}
